export enum CylinderType {
  n2 = 'n2',
  n3 = 'n3',
  n4 = 'n4',
  n5 = 'n5',
  n6 = 'n6',
  n8 = 'n8',
  n10 = 'n10',
  n12 = 'n12',
  rotary = 'rotary',
  na = 'na',
  other = 'other',
  unknown = 'unknown',
}

export const CylinderTypeValuesAbbrev: { [key in CylinderType]: string } = {
  n2: '2',
  n3: '3',
  n4: '4',
  n5: '5',
  n6: '6',
  n8: '8',
  n10: '10',
  n12: '12',
  rotary: 'Rotary',
  na: 'N/A',
  other: 'Other',
  unknown: 'Unknown',
};

export const CylinderTypeValues: { [key in CylinderType]: string } = {
  n2: '2 Cylinders',
  n3: '3 Cylinders',
  n4: '4 Cylinders',
  n5: '5 Cylinders',
  n6: '6 Cylinders',
  n8: '8 Cylinders',
  n10: '10 Cylinders',
  n12: '12 Cylinders',
  rotary: 'Rotary',
  na: 'N/A',
  other: 'Other',
  unknown: 'Unknown',
};

export const fromCylinderTypeValue = (value: string) => {
  switch (value) {
    case '2 Cylinders':
      return CylinderType.n2;
    case '3 Cylinders':
      return CylinderType.n3;
    case '4 Cylinders':
      return CylinderType.n4;
    case '5 Cylinders':
      return CylinderType.n5;
    case '6 Cylinders':
      return CylinderType.n6;
    case '8 Cylinders':
      return CylinderType.n8;
    case '10 Cylinders':
      return CylinderType.n10;
    case '12 Cylinders':
      return CylinderType.n12;
    case 'Rotary':
      return CylinderType.rotary;
    case 'N/A':
      return CylinderType.na;
    case 'Other':
      return CylinderType.other;
    case 'Unknown':
      return CylinderType.unknown;
    default:
      throw new Error(`invalid CylinderType value: ${value}`);
  }
};
